module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('request-status', {
    attrs: {
      "request": _vm.req
    }
  }), _vm._v(" "), (_vm.req.loading) ? _c('center', [_c('v-progress-circular', {
    staticClass: "my-4",
    attrs: {
      "color": "amber",
      "indeterminate": "",
      "size": "72"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.link && _vm.relationshipId) ? _c('share-card', {
    attrs: {
      "relationship-id": _vm.relationshipId,
      "links": _vm.links
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-07a24cc1","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/appointment/actions/ShareAppointment.vue
// module id = 1319
// module chunks = 9